<template>
    <div class="offset-md-3 col-md-6 mt-5">
        <ChangePassword />

        <div class="row border-bottom my-4"></div>

        <ChangeName />

        <div class="row border-bottom my-4"></div>

        <ChangeIdCode />

        <div class="row border-bottom my-4"></div>

        <ChangeLanguage />
    </div>
</template>

<script>
import ChangePassword from './ChangePassword';
import ChangeName from './ChangeName';
import ChangeLanguage from './ChangeLanguage';
import ChangeIdCode from '@views/Settings/Account/ChangeIdCode';

export default {
    components: {
        ChangeIdCode,
        ChangePassword,
        ChangeName,
        ChangeLanguage,
    },

    data() {
        return {};
    },
};
</script>
